import BaseLineupValidatorBuilder from 'services/sports/default/base-lineup-validator-builder';

export default class EditedLineupValidatorTiersBuilder extends BaseLineupValidatorBuilder {
    getInterface({incomingValues = {}}) {
        const {sportConfig, lineupPlayers} = incomingValues;

        return this.getMinGamesValidator(sportConfig, lineupPlayers);
    }
}
